import { MERGED_GUIDES } from './pages/blog/mergedGuides';
import { RETIRED_POSTS } from './pages/blog/retiredPosts';

/**
 * Permanent redirects (old path -> new path). Single source of truth for:
 * - the router, which renders <Navigate replace> for in-app navigation, and
 * - deploy/cloudfront-rewrite.js, which serves real 301s at the edge
 *   (regenerated by `npm run redirects`; redeploy the CloudFront Function after changes).
 */
export const REDIRECTS: Record<string, string> = {
  ...Object.fromEntries(
    Object.entries(MERGED_GUIDES).map(([blogSlug, pageSlug]) => [`/blog/${blogSlug}`, `/${pageSlug}`])
  ),
  ...Object.fromEntries(
    Object.entries(RETIRED_POSTS).map(([oldSlug, newSlug]) => [`/blog/${oldSlug}`, `/blog/${newSlug}`])
  ),
  '/features/refund-management': '/features/auto-allocation',
  '/resources/case-studies/ecommerce-carrier-refunds': '/resources/case-studies',
  '/route-optimization-software': '/features/route-planner',
  '/fleet-management-software': '/features/driver-app',
  '/last-mile-delivery-software': '/features/branded-tracking',
  '/resources/whitepapers': '/resources',
};
